import React, {useContext} from "react";
import {Link} from "react-router-dom";
import {LoggedInRoutes} from "../../LoggedInRoutes";
import {ClustersContext} from "../LoggedInApp";

export default function BackToClustersLink() {

  const {clusters} = useContext(ClustersContext);

  // The clusters page sends users with a single cluster straight back to it, so the link would lead nowhere.
  if (!clusters || clusters.length <= 1) {
    return null;
  }

  return (
      <Link to={LoggedInRoutes.CLUSTERS.INDEX} title="Back to all clusters">
        <i className="bx bx-chevrons-left cluster-back"/>
      </Link>
  )

}
